import React from 'react';
import {Link} from 'gatsby'
import Loadable from '@loadable/component'
const ModalVideo = Loadable(() => import('react-modal-video'))

const MainBanner = () => {
    // Popup Video
    const [isOpen, setIsOpen] = React.useState(true);
    const openModal = () => {
        setIsOpen(!isOpen);
    }

    // Calcular años desde 2002
    const currentYear = new Date().getFullYear();
    const yearsExperience = currentYear - 2002;

    return (
        <React.Fragment>
            {/* If you want to change the video need to update videoID */}
            <ModalVideo
                channel='youtube'
                isOpen={!isOpen}
                videoId='bk7McNUjWgw'
                onClose={() => setIsOpen(!isOpen)}
            />

            <div className="main-banner-item item-bg2">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            <div className="banner-item-content">
                                <span className="sub-title">IntraVR360</span>
                                <h1>Soluciona los Reportes Regulatorios</h1>
                                <p>La suite IntraVR360 integra, administra, valida y automatiza la generación y envío de Reportes Regulatorios a la CNSF.</p>
                                <p>Con {yearsExperience} años en el sector financiero y asegurador, nuestra experiencia incluye sistemas para bancos, aseguradoras, afianzadoras y varios tipos más de instituciones financieras.</p>

                                <div className="btn-box">
                                    <Link to="/about-us" className="default-btn">
                                        <i className="flaticon-right"></i>
                                        Conoce más<span></span>
                                    </Link>

                                    <Link
                                        to="#play-video"
                                        onClick={e => {e.preventDefault(); openModal()}}
                                        className="video-btn popup-youtube"
                                        style={{display: 'none'}}
                                    >
                                        <i className="flaticon-google-play"></i> Ver video
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default MainBanner;